function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M.71.71l20 20M20.71.71l-20 20"
}));

function SvgIconCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21.41 21.41"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMS40MSAyMS40MSI+PGcgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIj48cGF0aCBkPSJtLjcxLjcxIDIwIDIwIi8+PHBhdGggZD0ibTIwLjcxLjcxLTIwIDIwIi8+PC9nPjwvc3ZnPg==";
export { SvgIconCloseX as ReactComponent };